export const evilWizardAttack = new Image();
evilWizardAttack.src = "assets/characterSprites/evilWizard/Attack.png";
evilWizardAttack.width = 1200/8;
evilWizardAttack.height = 150/1;
evilWizardAttack.yOffset = 38;
evilWizardAttack.xOffset = 150;
evilWizardAttack.cycleLoop = [0,1,2,3,4,5,6,7];